export const LANGUAGE_SELECT_TITLE_ID = 'language-select-title';
